<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="orderInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="店铺名称" class='tiny'>
						<el-input style="width:300px;" v-model="orderInfo.storeName" placeholder="请输入店铺名称">
						</el-input>
					</el-form-item>
					<el-form-item label="分类名称" class='tiny'>
						<el-input style="width:300px;" v-model="orderInfo.className" placeholder="请输入分类名称">
						</el-input>
					</el-form-item>
				
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button type="primary" @click="empty">清空</el-button>
						</template>
					</el-form-item>
					<el-button type="primary" v-if="storeId!=0" @click="addCarousel">新增</el-button>
				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->
		<el-table :data="expressList" stripe style="width: 100%">
			<el-table-column type="index" align="center" width="90" label="#">
			</el-table-column>
			<el-table-column v-if="storeId==0" prop="storeName" label="店铺名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			
			<el-table-column prop="className" label="分类名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="bannerImage" label="banner图" align="center" >
				<template slot-scope="scope">
					<img :src="scope.row.bannerImage" style="width: 50px;height: 50px;border-radius: 50%;" />
				</template>
			</el-table-column>
			<el-table-column prop="image" label="分类图片" align="center" >
				<template slot-scope="scope">
					<el-button @click="lookDt(scope.row.image)">查看</el-button> 
				</template>
			</el-table-column>
			<el-table-column prop="orderIndex" label="排序" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
		
			<el-table-column prop="isShow" label="是否展示" align="center" :show-overflow-tooltip="true">

				<template slot-scope="scope">
					<span v-if="scope.row.isShow==true">是</span>
					<span v-if="scope.row.isShow==false">否</span>

				</template>
			</el-table-column>
			
			<el-table-column prop="createTime" label="创建时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop=""  label="操作"  fixed="right" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" v-if="storeId!=0" type="text" @click="editialogVisible(scope.row.id)">编辑</el-button>
					<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
					　　　　
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 新增 -->
		<el-dialog :visible.sync="dialogVisibleSwiper" title="添加分类" @close="addDialogClose" width="600px"
			:close-on-click-modal="false">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo" >
					<el-form-item label="分类名称" label-width="140px">
						<el-input type="text"  v-model="storeGoodsInfo.className"
							auto-complete="off" style="width:400px;" placeholder="请输入分类名称" />
					</el-form-item>
					<el-form-item label="排序" label-width="140px">
						<el-input type="text" v-model="storeGoodsInfo.orderIndex"
							auto-complete="off" placeholder="请输入排序号"  style="width:250px;"/>
							&nbsp;<span id="">
								  数值越大，排序越靠前
							</span>
					</el-form-item>
					
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="banner图(限制一张)" style="width: 100%;display: flex;align-items: initial;">
						<br />
						<!-- <span>尺寸建议（128*128px）</span> -->
							<el-upload :action="httpUrl1" list-type="picture-card" :on-preview="handlePictureCardPreview1"
								:on-remove="handleRemove1" :file-list="fileList1" :show-file-list="true" multiple :limit="1"
								:on-success="onSuccess1">
								<i class="el-icon-plus"></i>
							</el-upload>
						</el-form-item>
					</div>
									
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<el-form-item label="分类图片(限制一张)" style="width: 100%;display: flex;align-items: initial;">
								<br />
								<!-- <span>尺寸建议（260*160px）</span> -->
								<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
									:on-remove="handleRemove" :file-list="fileList" :show-file-list="true" multiple :limit="1"
									:on-success="onSuccess">
									<i class="el-icon-plus"></i>
								</el-upload>
							</el-form-item>
						</div>
									
					<el-form-item label="是否展示" label-width="140px">
						<el-switch v-model="storeGoodsInfo.isShow" :active-value="true" :inactive-value="false"
							class="switchss">
						</el-switch>
					</el-form-item>

					<el-button type="primary" @click="submit" style="margin-top: 100px;" :loading="submitLoading">提交</el-button>

				</el-form>
			</div>
		</el-dialog>
		<!-- 编辑修改 --> 
		<el-dialog :visible.sync="dialogVisibleSwipers" title="编辑分类" @close="addDialogClose" width="600px"
			:close-on-click-modal="false">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo">
					<el-form-item label="分类名称" label-width="140px">
						<el-input type="text" style="width: 400px;" v-model="storeGoodsInfo.className"
							auto-complete="off" placeholder="请输入分类名称" />
					</el-form-item>
					<el-form-item label="排序"  label-width="140px">
						<el-input type="text" style="width: 250px;" v-model="storeGoodsInfo.orderIndex"
							auto-complete="off" placeholder="请输入排序号" />&nbsp;<span id="">
								  数值越大，排序越靠前
							</span>
					</el-form-item>
					
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="banner图(限制一张)" style="width: 100%;display: flex;align-items: initial;">
						<br />
						<!-- <span>尺寸建议（128*128px）</span> -->
							<el-upload :action="httpUrl1" list-type="picture-card" :on-preview="handlePictureCardPreview1"
								:on-remove="handleRemove1" :file-list="fileList1" :show-file-list="true" multiple :limit="1"
								:on-success="onSuccess1">
								<i class="el-icon-plus"></i>
							</el-upload>
						</el-form-item>
					</div>
									
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<el-form-item label="分类图片(限制一张)" style="width: 100%;display: flex;align-items: initial;">
								<br />
								<!-- <span>尺寸建议（260*160px）</span> -->
								<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
									:on-remove="handleRemove" :file-list="fileList" :show-file-list="true" multiple :limit="1"
									:on-success="onSuccess">
									<i class="el-icon-plus"></i>
								</el-upload>
							</el-form-item>
						</div>
									
					<el-form-item label="是否展示" label-width="140px">
						<el-switch v-model="storeGoodsInfo.isShow" :active-value="true" :inactive-value="false"
							class="switchss">
						</el-switch>
					</el-form-item>
							
					<el-button type="primary" @click="submitClick" style="margin-top: 100px;" :loading="submitClickLoading">提交</el-button>
				
				</el-form>
				
			</div>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisibleImg" :closeOnClickModal="false">
			<div style="text-align: center;">
				<img width="100%"  class="el-upload-list__item-thumbnail" :src="dialogImageUrl" alt="">
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('goods');
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				sliderlist:{},
				expressList: [],
				orderInfo: {},
				storeGoodsInfo: {},
				dialogVisibleSwiper: false,
				dialogVisibleSwipers: false,
				dialogVisibleImg:false,
				storeId:window.sessionStorage.getItem('storeId'),
				dialogImageUrl:'',
				httpUrl: urls,
				httpUrl1: urls,
				fileList: [],
				fileList1: [],
				goodsImages:[],
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
										header: 1,
									},
									{
										header: 2,
									},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
										list: "ordered",
									},
									{
										list: "bullet",
									},
								], // 列表
								[{
										script: "sub",
									},
									{
										script: "super",
									},
								], // 上下标
								[{
										indent: "-1",
									},
									{
										indent: "+1",
									},
								], // 缩进
								[{
									direction: "rtl",
								}, ], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								}, ], // 字体大小
								[{
										color: [],
									},
									{
										background: [],
									},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								}, ], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function(value) {
									console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},
				
						},
					},
					theme: "snow",
				},

				submitLoading: false,
				submitClickLoading: false,
			}
		},
		methods: {
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 8MB!');
					return false;
				}
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				}
				return isLt2M, imgStr;
			},
			upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.message !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			uploadError() {
				this.$message.error("图片上传失败");
			},
			onEditorReady(editor) {
				// 准备编辑器
				// console.log(editor);
			},
			onSuccess(response, file, fileList) {
				console.log(file,urls,fileList)
				this.storeGoodsInfo.image=file.response.message
				
			},
			onSuccess1(response, file, fileList1) {
				
				this.storeGoodsInfo.bannerImage=file.response.message
					
			},
			handleRemove(file, fileList) {
			
					this.storeGoodsInfo.image=''
		
			
			},
			handleRemove1(file, fileList) {
			
					this.storeGoodsInfo.bannerImage=''
			
			
			},
			handlePictureCardPreview(file) {
				console.log(file)
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			handlePictureCardPreview1(file) {
				console.log(file)
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			lookDt(item){
			console.log(item)
			this.dialogImageUrl = item;
			this.dialogVisibleImg = true;
			},
			search() { //查询
					
				this.pmsbrdselect()

			},
			empty() { //清空
				this.orderInfo = {}
				this.page.pageNum=1
			},
			addDialogClose() {
				console.log('aaa')

				this.storeGoodsInfo = {}
			},
			pmsbrdselect() {
				let data = {
					 pageNum: this.page.pageNum,
					 pageSize: this.page.pageSize,
					 className:this.orderInfo.className,
				
					 storeName:this.orderInfo.storeName
					// name:this.orderInfo.name
				}
				this.$api.findSsGoodsClass(data).then((res) => {
					console.log(res)
					if (res.state == 'success') {
						this.expressList = res.data.list
						this.sliderlist = res.data
					}
				})

			},
			// 新增
			addCarousel() {
				this.fileList = [];
				this.fileList1 = [];
				this.dialogVisibleSwiper = true

			},

			// 提交
			submit() {
				this.submitLoading = true;
				let data = this.storeGoodsInfo
				// console.log(data)
				this.$api.addGoodssClass(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.pmsbrdselect()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
					}
					this.submitLoading = false;
				})

			},

			// 编辑
			editialogVisible(e) {
			
				this.fileList = [];
				this.fileList1 = [];
				console.log(e)
				this.$api.findByIdclass(e).then((res) => {
					if (res.state == 'success') {
						console.log(res.data);
						this.storeGoodsInfo = res.data
						// console.log(this.storeGoodsInfo)
						this.storeGoodsInfo.showStatus = res.data.showStatus
						this.storeGoodsInfo.image=res.data.image
						urls=res.data.image
					
						if(res.data.image!=''){
							this.fileList.push({
								
								url:res.data.image
							})
						}
						if(res.data.bannerImage!=''){
							this.fileList1.push({
								
								url:res.data.bannerImage
							})
						}
						this.dialogVisibleSwipers = true
				
					}
				})
				
			},
			// 编辑修改提交
			submitClick() {
				// console.log(urls)
				this.submitClickLoading = true;
				let data ={
					"id": this.storeGoodsInfo.id,
					"className": this.storeGoodsInfo.className,
				
					"isShow": this.storeGoodsInfo.isShow,
					"orderIndex": this.storeGoodsInfo.orderIndex,
				
					"bannerImage": this.storeGoodsInfo.bannerImage,
					"image": this.storeGoodsInfo.image,
				
				}
			
				this.$api.addGoodssClass(data).then((res) => {
					// console.log(res)
					console.log(123456,res);
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						
						this.dialogVisibleSwipers = false
						this.pmsbrdselect();
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
					}
					this.submitClickLoading = false;
				})

			},
			// 删除
			toDelete(e) {
				console.log(e)
				var str = "此操作将删除该分类, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
				
					this.$api.delByIdclass(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.pmsbrdselect();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			pageChange(data) {
				this.page.pageNum = data
				this.pmsbrdselect();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.pmsbrdselect()
			},
		},




		created() {
			this.pmsbrdselect()

		}
	}
</script>

<style>

</style>
